module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'Create New School',
      "headerStyle": 'font-size: 24px; font-weight: bold',
      "width": '600px',
      "padding": '2em'
    }
  }, [_c('pl-input', {
    attrs: {
      "labelText": 'School name',
      "placeholder": 'add school name'
    },
    model: {
      value: (_vm.school_name),
      callback: function($$v) {
        _vm.school_name = $$v
      },
      expression: "school_name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt3 center-xs"
  }, [_c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(" CANCEL ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.school_name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSchool.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      CREATE SCHOOL\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-58235a53!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/editSchoolModal.vue
// module id = 1969
// module chunks = 61